import React, { useState, useEffect, useContext } from 'react';
import { Heart, MapPin, ChevronDown, ChevronUp, Users } from 'lucide-react';
import { FaHotel, FaSuitcase } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import "../../../../assets/css/customer/customerdashboard/customerWishlist/wishlistPackageCards.css";

const normalizeItem = (item, imageBaseUrl, baseUrl) => {
    if (item.jjpackage_id && item.jjpackage) {
        const pkg = item.jjpackage;
        return {
            type: 'package',
            wishlistId: item.id,
            refId: pkg.id,
            title: pkg.package_name,
            image: pkg.package_image ? `${imageBaseUrl}/${pkg.package_image}` : null,
            price: pkg.package_price,
            days: pkg.duration_days,
            nights: pkg.duration_nights,
            location: pkg.location || pkg.package_destination,
            maxPeople: pkg.max_people_size,
            category: pkg.package_category,
            description: pkg.package_description,
            raw: pkg,
        };
    }

   if (item.jjdestination_id && item.jjdestination) {
    const dest = item.jjdestination;
    
    const img = (dest.image ? `${imageBaseUrl}/${dest.image}` : null)
        || (dest.jjdestinationgallerys?.[0]?.des_gallery
            ? `${imageBaseUrl}/${dest.jjdestinationgallerys[0].des_gallery}`
            : null);

    return {
        type: 'destination',
        wishlistId: item.id,
        refId: dest.id,
        title: dest.destination_name,
        image: img,
        location: `${dest.district}, ${dest.province}`,
        category: 'Destination',
        description: dest.description,
        raw: dest,
    };
}

    if (item.jjhotelregistration_id && item.jjhotel) {
        const hotel = item.jjhotel;
        const img = hotel.hotel_image
            ? `${baseUrl.replace('/api', '')}/storage/${hotel.hotel_image}`
            : null;
        return {
            type: 'hotel',
            wishlistId: item.id,
            refId: hotel.id,
            title: hotel.hotel_name,
            image: img,
            location: hotel.address,
            category: 'Hotel',
            description: hotel.description,
            raw: hotel,
        };
    }

    return null;
};

const WishlistTypeSection = ({ title, icon, items, expandedId, setExpandedId, onRemove, onViewDetails }) => {
    if (items.length === 0) return null;

    return (
        <div className="cus-wl-pkg-type-section">
            <h4 className="cus-wl-pkg-type-section-title">
                {icon} {title} <span className="cus-wl-pkg-type-count">({items.length})</span>
            </h4>

            <div className="cus-wl-pkg-cards-grid">
                {items.map(normalized => {
                    const isExpanded = expandedId === normalized.wishlistId;
                    const otherExpanded = expandedId !== null && expandedId !== normalized.wishlistId;

                    return (
                        <div
                            key={normalized.wishlistId}
                            className={`cus-wl-pkg-card-item ${isExpanded ? 'expanded' : ''} ${otherExpanded ? 'shrink' : ''}`}
                            onClick={() => setExpandedId(prev => (prev === normalized.wishlistId ? null : normalized.wishlistId))}
                        >
                            {/* REMOVE */}
                            <button
                                className="cus-wl-pkg-remove-btn"
                                onClick={(e) => onRemove(normalized, e)}
                            >
                                <Heart size={18} fill="white" color="white" />
                            </button>

                            {/* IMAGE */}
                            <div className="cus-wl-pkg-card-img-wrap">
                                {normalized.image ? (
                                    <img src={normalized.image} alt={normalized.title} className="cus-wl-pkg-card-img" />
                                ) : (
                                    <div className="cus-wl-pkg-card-img-placeholder">
                                        {normalized.type === 'hotel'
                                            ? <FaHotel size={28} color="#a0aec0" />
                                            : <MapPin size={28} color="#a0aec0" />}
                                    </div>
                                )}
                                <div className="cus-wl-pkg-card-overlay">
                                    <h5>{normalized.title}</h5>
                                </div>
                            </div>

                            {/* CONTENT */}
                            <div className="cus-wl-pkg-card-content">
                                <div className="cus-wl-pkg-price-row">
                                    {normalized.price ? (
                                        <div className="cus-wl-pkg-amount-box">
                                            <small>PKR </small>
                                            <span>{normalized.price}</span>
                                        </div>
                                    ) : (
                                        <div className="cus-wl-pkg-amount-box">
                                            <span className="cus-wl-pkg-location-fallback">{normalized.location}</span>
                                        </div>
                                    )}
                                    {(normalized.days || normalized.nights) && (
                                        <div className="cus-wl-pkg-duration">
                                            {normalized.days}D / {normalized.nights}N
                                        </div>
                                    )}
                                </div>

                                {normalized.category && (
                                    <div className="cus-wl-pkg-features">
                                        <span className="cus-wl-pkg-feature-tag">{normalized.category}</span>
                                    </div>
                                )}

                                <div className="cus-wl-pkg-expand-hint">
                                    {isExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                                    <span>{isExpanded ? 'Less' : 'More'}</span>
                                </div>

                                {isExpanded && (
                                    <div className="cus-wl-pkg-expanded-details">
                                        <div className="cus-wl-pkg-info-row">
                                            {normalized.location && (
                                                <div className="cus-wl-pkg-info-item">
                                                    <MapPin size={14} />
                                                    <span>{normalized.location}</span>
                                                </div>
                                            )}
                                            {normalized.maxPeople && (
                                                <div className="cus-wl-pkg-info-item">
                                                    <Users size={14} />
                                                    <span>Up to {normalized.maxPeople} people</span>
                                                </div>
                                            )}
                                        </div>

                                        {normalized.description && (
                                            <p className="cus-wl-pkg-short-desc">
                                                {normalized.description.length > 110
                                                    ? normalized.description.slice(0, 110) + '…'
                                                    : normalized.description}
                                            </p>
                                        )}

                                        <div className="cus-wl-pkg-card-actions">
                                            <button
                                                className="cus-wl-pkg-view-btn"
                                                onClick={(e) => onViewDetails(normalized, e)}
                                            >
                                                View Details
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const WishlistSection = () => {

    const { baseUrl, authToken, imageBaseUrl } = useContext(AppContext);
    const navigate = useNavigate();
    const [wishlistItems, setWishlistItems] = useState([]);
    const [loading, setLoading]             = useState(true);
    const [error, setError]                 = useState(null);
    const [expandedId, setExpandedId]       = useState(null);
    const getHeaders = () => ({
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json',
    });

    const fetchWishlist = () => {
        setLoading(true);
        setError(null);

        axios
            .get(`${baseUrl}/customer/wishlist`, { headers: getHeaders() })
            .then((res) => {
                if (res.data.success) {
                    setWishlistItems(res.data.data);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.error('Wishlist fetch error:', err);
                setError('Wishlist load nahi ho saki. Please login karein.');
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchWishlist();
    }, []);

    const normalizedItems = wishlistItems
        .map((item) => normalizeItem(item, imageBaseUrl, baseUrl))
        .filter(Boolean);

    const packageItems     = normalizedItems.filter(i => i.type === 'package');
    const destinationItems = normalizedItems.filter(i => i.type === 'destination');
    const hotelItems       = normalizedItems.filter(i => i.type === 'hotel');

    const handleRemove = (normalized, e) => {
        e.stopPropagation();
        if (!window.confirm('Remove this item from wishlist?')) return;

        axios
            .delete(`${baseUrl}/customer/wishlist/${normalized.refId}?type=${normalized.type}`, {
                headers: getHeaders(),
            })
            .then((res) => {
                if (res.data.success) {
                    setWishlistItems(prev => prev.filter(item => item.id !== normalized.wishlistId));
                    if (expandedId === normalized.wishlistId) setExpandedId(null);
                }
            })
            .catch((err) => {
                console.error('Remove error:', err);
                alert('Remove nahi ho saka. Dobara try karein.');
            });
    };

    const handleViewDetails = (normalized, e) => {
        e.stopPropagation();

        if (normalized.type === 'package') {
            navigate(`/packages/${normalized.refId}`);
        } else if (normalized.type === 'destination') {
            navigate(`/destinations?id=${normalized.refId}`);
        } else if (normalized.type === 'hotel') {
            navigate('/hotels');
        }
    };

    if (loading) {
        return (
            <div className="cus-wl-pkg-empty">
                <p>Loading wishlist...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="cus-wl-pkg-empty">
                <p style={{ color: 'red' }}>{error}</p>
            </div>
        );
    }

    return (
        <div>
            {/* HEADER */}
            <div className="cus-wl-pkg-header-card">
                <div className="cus-wl-pkg-header-inner">
                    <Heart size={32} fill="white" color="white" />
                    <h3>My Wishlist</h3>
                </div>
                <p>{normalizedItems.length} saved item{normalizedItems.length !== 1 ? 's' : ''} for your next adventure</p>
            </div>

            {/* EMPTY */}
            {normalizedItems.length === 0 && (
                <div className="cus-wl-pkg-empty">
                    <Heart size={64} />
                    <h5>Your wishlist is empty</h5>
                    <p>Start saving your favorite destinations, packages, and hotels!</p>
                </div>
            )}

            <WishlistTypeSection
                title="Destinations"
                icon={<MapPin size={18} />}
                items={destinationItems}
                expandedId={expandedId}
                setExpandedId={setExpandedId}
                onRemove={handleRemove}
                onViewDetails={handleViewDetails}
            />

            <WishlistTypeSection
                title="Packages"
                icon={<FaSuitcase size={16} />}
                items={packageItems}
                expandedId={expandedId}
                setExpandedId={setExpandedId}
                onRemove={handleRemove}
                onViewDetails={handleViewDetails}
            />

            <WishlistTypeSection
                title="Hotels"
                icon={<FaHotel size={16} />}
                items={hotelItems}
                expandedId={expandedId}
                setExpandedId={setExpandedId}
                onRemove={handleRemove}
                onViewDetails={handleViewDetails}
            />

            {/* STATS */}
            {normalizedItems.length > 0 && (
                <div className="cus-wl-pkg-stats-card">
                    <div className="cus-wl-pkg-stats-grid">
                        <div className="cus-wl-pkg-stat-item">
                            <h2>{destinationItems.length}</h2>
                            <small>Saved Destinations</small>
                        </div>
                        <div className="cus-wl-pkg-stat-item">
                            <h2>{packageItems.length}</h2>
                            <small>Saved Packages</small>
                        </div>
                        <div className="cus-wl-pkg-stat-item">
                            <h2>{hotelItems.length}</h2>
                            <small>Saved Hotels</small>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default WishlistSection;